import { Controller } from './src/Controller'
export {Controller}
export default Controller



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Controller/index.ts